export const CHECK_FILTER = "CHECK_FILTER";

export const FILTER_GET_NEXT_STEP = "FILTER_GET_NEXT_STEP";
